import { render, staticRenderFns } from "./claim-detail.vue?vue&type=template&id=f70b706c&scoped=true&"
import script from "./claim-detail.vue?vue&type=script&lang=js&"
export * from "./claim-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70b706c",
  null
  
)

export default component.exports